import { isMobile } from "react-device-detect"
import { useState } from "react";
import services from "../services.js" 
import ProgressBar from "./ProgressBar.js";

const Subscribe = (props) => {
    const [email, setEmail] = useState("")
    const [checkRobot, setCheckRobot] = useState(false)
    const [progress, setProgress] = useState(false)
    const {prefix, serial, setNotification, statusInfo} = props
    
    const handleEmail = (e)=>{
        let email = e.target.value
        email = email ? email.toLowerCase() : ""
        setEmail(email)
    }

    const handleCheckRobot = (e)=>{
        let checked = e.target.checked
        setCheckRobot(checked)
    }

    const isValidEmail = (email) =>{
        
        if(!email) {
            return false
        }else{
            const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return reg.test(email.toString().toLowerCase());
        }	
    }

    const subscribe = async()=> {
 
        setNotification(null)
        let messages = []
        let error = false

        if(!isValidEmail(email)){
            error = true 
            messages.push("Please fill in a valid email address.")
        }

        if(!checkRobot){
            error = true 
            messages.push("Please check the \"I'm not robot\" checkbox to send email")
        }

        if(error){

             setNotification({
                type : 'warning',
                message : messages,
                notificationBottom : true
            })

            return
        }

        let lastStatus = statusInfo && statusInfo[0] ? statusInfo[0].status : ""  ;
        let lastTimeStamp =  statusInfo && statusInfo[0] ? statusInfo[0].event_date_utc : ""  ;

        let data = {
            email : email,
            prefix : prefix,
            serial : serial,
            current_status : lastStatus,
            event_date_utc : lastTimeStamp.toString(),
        }


       setProgress(true)

        let response = await services.post("/notification/subscribe", data)
    
        if(response.error){
            error = true 
            messages.push(response.message ? response.message : "")
        }else{
            error = false
            messages.push("You successfully subscribed to notifications for this AWB.")
        }


        setNotification({
            type : error ? 'error' : 'success',
            message : messages,
            notificationBottom : true
        })
    
       setProgress(false)

    }

    const sendAWB = async() =>{
      
        setNotification(null)
        let messages = []
        let error = false
        
        if(!isValidEmail(email)){
            error = true
            messages.push("Please fill in a valid email address.")
        }

        if(!checkRobot){
            error = true
            messages.push("Please check the \"I'm not robot\" checkbox to send email")
        }

        if(error){

             setNotification({
                type : 'warning',
                message : messages,
                notificationBottom : true
            })

            return
        }

        let data = {
            email : email,
            prefix : prefix,
            serial : serial,
        }

        setProgress(true)

        let response = await services.post("/notification/awbInfos", data)

        if(response.error){
            error = true 
            messages.push(response.message ? response.message : "")
        }else{
            error = false
            messages.push("You successfully sent AWB info.")
        }

        
        setNotification({
            type : error ? 'error' : 'success',
            message : messages,
            notificationBottom : true
        })
        
       setProgress(false)

    }
 
    return (
        <section>
            <div className="card secondary" id="table_subscribe">
                <div className={isMobile ? "" : "row side-elements"}>
                  <div className="columns three"></div>
                  <div className="columns three">
                      <input 
                        type="text" 
                        id="form_mail"   
                        placeholder="Enter your email address"
                        onChange={handleEmail} 
                        defaultValue={email} 
                        style={{ fontSize : "1.2rem"}}
                      />
                  </div>

                  <div style={{margin :"1em"}}> 
                    <center>
                        <input 
                         type="checkbox" 
                            id="notrobot" 
                            name="notrobot" 
                            onClick={handleCheckRobot}
                        />
                        <label for="notrobot">I'm not a robot</label>
                    </center>
                    
                  </div>
                            
                  <div className="" style={{marginRight : '0.5em'}}> 
                    <center>
                        <input type="submit"  
                            onClick = {sendAWB}  
                            value ="Send this AWB info" 
                        /> 
                    </center>
                    
                  </div>
                 {
                    <center>
                      {isMobile ? <br/> : null}
                      <ProgressBar show={progress} />
                    </center>
                  }

                  <div className="" style={{marginLeft : '0.5em'}}>
                    <center>
                        <input type="submit"  
                            onClick={subscribe}  
                            value ="Subscribe to notifications for this AWB" />  
                    </center>
                    
                  </div>
                
                </div>

            </div>
          </section>
          
    );
};
export default Subscribe;